// extracted by mini-css-extract-plugin
export default {"notebookSpineContainer":"NotebookSpine_notebookSpineContainer__lBK0Y","notebookSpineImage":"NotebookSpine_notebookSpineImage__guhD1"};